import { initAISummary } from "crosstalk-comments-livechat-sdk";
export function autoInitAISummaries() {
    const aiDivs = document.querySelectorAll('div[data-crosstalk-ai-summary]');
    const aiEmbeds = [];
    aiDivs.forEach(aiDiv => {
        const config = {
            wp: aiDiv.dataset.wp || "",
            url: aiDiv.dataset.url || "",
            theme: aiDiv.dataset.theme || "light",
            height: aiDiv.dataset.height || "160px"
        };
        const instance = initAISummary(aiDiv, config);
        if (instance)
            aiEmbeds.push(instance);
    });
    return aiEmbeds;
}
